import slugify from 'slugify';

const SLUG_SEPARATOR = '-';

export const getSlug = (folder: {
  id: string;
  name: string;
}): string | null => {
  return folder?.id
    ? [
        encodeURIComponent(slugify(folder?.name ?? '', { strict: true })),
        folder.id,
      ].join(SLUG_SEPARATOR)
    : null;
};
